import moment from 'moment';

export default {
  isBefore(sourceDate, targetDate, mode) {
    if (mode === 'week') {
      const sourceWeek = sourceDate.week();
      const sourceYear = sourceDate.year();
      const targetWeek = targetDate.week();
      const targetYear = targetDate.year();

      if (sourceYear === targetYear) {
        return sourceWeek < targetWeek;
      } else if (sourceYear > targetYear) {
        return false;
      }

      return true;
    }

    return sourceDate.isBefore(targetDate, 'day');
  },

  isAfter(sourceDate, targetDate, mode) {
    if (mode === 'week') {
      const sourceWeek = sourceDate.week();
      const sourceYear = sourceDate.year();
      const targetWeek = targetDate.week();
      const targetYear = targetDate.year();

      if (sourceYear === targetYear) {
        return sourceWeek > targetWeek;
      } else if (sourceYear > targetYear) {
        return true;
      }

      return false;
    }

    return sourceDate.isAfter(targetDate, 'day');
  },

  calculateTimeDiff(then) {
    const now = moment();
    const diff = now.diff(then);
    const duration = moment.duration(diff);
    const data = {};

    if (diff > 0) {
      data.full = duration.format('HH:mm:ss', { trim: false });
      data.hours = duration.hours();
      data.minutes = duration.minutes();
      return data;
    }

    return false;
  },

  getDays(date1, date2) {
    const a = moment(date1);
    const b = moment(date2);

    const ms = b.diff(a, 'milliseconds');

    const days = moment.duration(ms).locale('precise-en').humanize();

    if (b.diff(a, 'days') === 0 && b.diff(a, 'hours') === 8) {
      return 'a day';
    }
    return days;
  },

  getHours(date1, date2) {
    const a = moment(date1);
    const b = moment(date2);

    const ms = b.diff(a, 'milliseconds');

    const days = moment.duration(ms).locale('precise-en').humanize();
    return days;
  },
};



// WEBPACK FOOTER //
// ./src/services/calendarService.js